var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class ewJSONExerciseCancelPayment extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.eier = 0;
        /** @override */ this.id = 0;
        /** @override */ this.orderID = '';
        /** @override */ this.state = '';
    }
}
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "avdeling", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "avdelingnavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "book_inntil", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "booked", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "booked_text", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "booking", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "booking_starts_at", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "color", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "cost", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "cost_excluded_vat", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "dagerfor", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "dato", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "eier", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "error", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "free", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "gren", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "grennavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "gyldig_fra", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "gyldig_til", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "instructor", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewJSONExerciseCancelPayment.prototype, "is_attending", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "klipp", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "lang_beskrivelse", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "min", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "orderID", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "res_slettes", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "sal", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "salnavn", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], ewJSONExerciseCancelPayment.prototype, "skjul_antall_ledige", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "slett_vente_min", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "source", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "state", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "tema_time", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "tidspunkt", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "tim", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewJSONExerciseCancelPayment.prototype, "tittel", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "varighet", void 0);
__decorate([
    nullable,
    __metadata("design:type", Number)
], ewJSONExerciseCancelPayment.prototype, "waitingspot", void 0);
